// ---------------------------------------------------------------------------
// ErrorStep — Non-recoverable error screen (401, 404, expired)
// ---------------------------------------------------------------------------

import { StepHeading } from '@/components/shared/StepHeading';
import { t } from '@/i18n';
import styles from './ErrorStep.module.css';

interface ErrorStepProps {
  message?: string;
}

export function ErrorStep({ message }: ErrorStepProps) {
  return (
    <div className={styles['wrapper']} role="alert">
      {/* Warning triangle icon */}
      <svg className={styles['icon']} viewBox="0 0 24 24" aria-hidden="true">
        <path
          d="M12 2L1 21h22L12 2z"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinejoin="round"
        />
        <line
          x1="12"
          y1="9"
          x2="12"
          y2="13"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
        />
        <circle cx="12" cy="17" r="1" fill="currentColor" />
      </svg>

      <StepHeading title={t('error.title')} subtitle={message ?? t('error.fallback')} />
    </div>
  );
}
